import { push } from 'connected-react-router'
import { LinkStuff } from '../interface/MyInterfaces'
import { handleReportDisplayIdChange_VendorReport2025, authenticateUserOutsideLogin } from './UserActions';
import { percentageFormat, arrayToCsv, billionNumberFormat, numberWithCommas, isAgg, isAllIris, replaceRu4mPossessive } from '../components/Common/Helpers';
import { authHeader } from '../javascript/auth-header';
import JSZip from "jszip";
import { saveAs } from 'file-saver';
import * as Helpers from '../components/Common/Helpers';
import { setTab42025 } from './LoadNewVendorReportText';
import { HomeState } from "../interface/VendorReportInterface";

let BVD_MATCH_RATES;

function dispatchVendorTab1(
    dispatch,
    headers,
    display_id,
    vintage,
    payload
) {
    if (isAgg(display_id)) {
        const membersUrl = '/IRISReportsMicroservice/api/VendorReport2025/get_all_member_universities/' + display_id + '/' + vintage;
        fetch(membersUrl, { method: 'GET', headers: headers })
            .then(function (resp) { return resp.text(); })
            .then(function (text) { payload.allMemberUniversities = sortUniversityList(text); })
            .catch(function () { /* ignore */ })
            .finally(function () {
                dispatch({ type: "VENDOR_TAB1", payload });
            });
    } else {
        dispatch({ type: "VENDOR_TAB1", payload });
    }
}

function sortUniversityList(universities: string): string {
    if (!universities) return "";
    return universities
        .split(",")
        .map(name => name.trim())
        .filter(Boolean)
        .sort((a, b) => a.localeCompare(b))
        .join(", ");
}

export function loadNewVendorReportTab12025(display_id, census_vintage, vintage) {
    return dispatch => {
        dispatch(loadHomeState_AndOtherStuff2025(display_id, vintage));
        dispatch(loadStates2025());
    }
}

export function loadHomeState_AndOtherStuff2025(display_id, vintage) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/VendorReport2025/homestate/' + display_id;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "HOMESTATE2025",
                    payload: json[0]
                });
                const institutionName = getInstitutionName(json[0]?.campusname);
                dispatch({
                    type: "INSTITUTION_NAME",
                    payload: institutionName
                });
                dispatch(loadBVDMatchRates2025(display_id, vintage, json[0], institutionName));
                dispatch(loadReleaseDate2025(display_id, vintage));
            });
    };
}

function buildYearRangeHtml(row, homeState, agg) {
    if (!row) return "<ul></ul>";

    const {
        national_spending, national_vendors,
        in_state_spending, in_state_vendors,
        small_business_spending, small_business_vendors
    } = row;

    return `<ul><li>${numberWithCommas(national_vendors)} vendors and subcontractors received ${billionNumberFormat(national_spending)}</li><li>${numberWithCommas(in_state_vendors)} ${agg ? `in-state` : homeState} vendors and subcontractors received ${billionNumberFormat(in_state_spending)}</li><li>${numberWithCommas(small_business_vendors)} small businesses received ${billionNumberFormat(small_business_spending)}</li></ul>`.trim();
}

function buildSelectedYearHtml(row, homeState, agg) {
    if (!row) return "<ul></ul>";

    const {
        national_spending, national_vendors,
        in_state_spending, in_state_vendors,
        small_business_spending, small_business_vendors
    } = row;

    return `<ul><li>${numberWithCommas(national_vendors)} vendors and subcontractors received ${billionNumberFormat(national_spending)}</li><li>${numberWithCommas(in_state_vendors)} ${agg ? `in-state` : homeState} vendors and subcontractors received ${billionNumberFormat(in_state_spending)}</li><li>${numberWithCommas(small_business_vendors)} small businesses received ${billionNumberFormat(small_business_spending)}</li></ul>`.trim();
}

function buildTopDescription(display_id, institutionName) {
    const agg = isAgg(display_id);
    return `<b>About this report:</b> The Vendor Profile Report examines ${getPossessiveInstitutionName(agg, institutionName)} impact on vendors and subcontractors that provide research-related goods and services. This report uses data provided by ${institutionName} to IRIS to explore how direct purchases and subawards made on federal and non-federal research awards supported a variety of businesses and industries. Payments to individuals or to businesses outside the United States were excluded.
<br /><br />
The <b>Vendor Profile</b> page summarizes total spending and the number of establishments supported nationally, in-state, and among small businesses, and tracks how these figures change over time. The <b>Industry Revenue Analysis</b> page highlights the distribution of spending by industry. The <b>Methodology</b> page provides details on the data and report production process. <br /><br />`
}

function buildBenchmarkingHighlightsHtml(row, institutionName) {
    if (!row) return "";

    const {in_state_vendor_pct, in_state_spending_pct, small_business_vendor_pct, small_business_spending_pct} = row;

    return `At ${institutionName}, ${in_state_vendor_pct}% of vendors and ${in_state_spending_pct}% of total research spending were in-state. Small businesses made up ${small_business_vendor_pct}% of vendors and received ${small_business_spending_pct}% of spending.`;
}

function buildBenchmarkingDescriptionHtml(selected_year: number, universityName?: string) {
    const allIris = isAllIris(universityName);
    return `This chart shows${!allIris ? ' how' : ''} the percentages of spending totals and vendor types${!allIris ? ' compared with all other IRIS member universities for ' + selected_year : ''}.`
}

function buildHighlightsHtml(rangeRow, institutionName) {    
    return `${institutionName} spent ${billionNumberFormat(rangeRow.national_spending)} in research funding with establishments in the United States between fiscal years ${rangeRow.start_fy} - ${rangeRow.end_fy}.`
}

export function selectedYearChange2025(selectedYear, allData, universityName, stateName, agg) {
    const row = allData?.find(r => r.start_fy === selectedYear && r.start_fy === r.end_fy);

    return dispatch => {
        dispatch({
            type: "SELECTED_YEAR",
            payload: selectedYear
        })
        const highlightsSelectedYear = buildSelectedYearHtml(row, stateName, agg);
        const benchmarkingHighlights = buildBenchmarkingHighlightsHtml(row, universityName);
        const benchmarkingDescription = buildBenchmarkingDescriptionHtml(selectedYear, universityName);
        const payload: any = {
            highlightsSelectedYear,
            benchmarkingHighlights,
            benchmarkingDescription,
            selectedYear,
            benchmarkUniversityList: row?.benchmark_university_list
        };
        dispatch({
            type: "SELECTED_YEAR_CHANGE",
            payload
        })
    }
}

export function loadVendorProfile_Tab12025(display_id, vintage, homeState, campusname, bvdmatchrates, institutionName, possessiveInstitutionName) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/VendorReport2025/vendor_profile2025/' + display_id + '/' + vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (allData) {
                const selectedRow = allData
                    .filter(r => r.start_fy === r.end_fy)
                    .reduce((max, r) => (r.start_fy > (max?.start_fy ?? 0) ? r : max), null);
                const rangeRow = allData?.find(r => r.start_fy !== r.end_fy);
                const agg = isAgg(display_id);

                const highlightsYearRange = buildYearRangeHtml(rangeRow, homeState.statename, agg);
                const highlightsSelectedYear = buildSelectedYearHtml(selectedRow, homeState.statename, agg);
                const benchmarkingDescription = buildBenchmarkingDescriptionHtml(selectedRow.start_fy, institutionName);
                const benchmarkingHighlights = buildBenchmarkingHighlightsHtml(selectedRow, institutionName);
                const highlights = buildHighlightsHtml(rangeRow, institutionName);
                const topDescription = buildTopDescription(display_id, institutionName);
                // Individual universities use the selected-year list for benchmarking text.
                const benchmarkUniversityList = selectedRow?.benchmark_university_list;

                let minYear = Infinity;
                let maxYear = -Infinity;
                for (const { start_fy, end_fy } of allData ?? []) {
                    if (start_fy !== end_fy) continue;

                    if (start_fy < minYear) minYear = start_fy;
                    if (start_fy > maxYear) maxYear = start_fy;
                }
                minYear = isFinite(minYear) ? minYear : null;
                maxYear = isFinite(maxYear) ? maxYear : null;

                dispatch(loadSunburstBVDData2025(display_id, vintage, homeState, rangeRow, bvdmatchrates, institutionName, possessiveInstitutionName));
                dispatch({
                    type: "SELECTED_YEAR",
                    payload: selectedRow.start_fy
                })
                const tab1Payload = {
                    topDescription: topDescription,
                    minYear: minYear,
                    maxYear: maxYear,
                    selectedYear: selectedRow.start_fy,
                    isAgg: agg,
                    highlightsYearRange: highlightsYearRange,
                    highlightsSelectedYear: highlightsSelectedYear,
                    benchmarkingDescription: benchmarkingDescription,
                    benchmarkingHighlights: benchmarkingHighlights,
                    highlights: highlights,
                    benchmarkUniversityList: benchmarkUniversityList,
                    allMemberUniversities: ""
                };
                dispatchVendorTab1(dispatch, headers, display_id, vintage, tab1Payload);
                dispatch({
                    type: "VENDOR_PROFILE_TAB1_ALL_DATA",
                    payload: allData
                })
            });
    };
}

export function loadStates2025() {
    return dispatch => {
        let url = "/IRISReportsMicroservice/api/SpendingReport/states";

        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "US_STATES",
                    payload: json
                });
            });
    };
}


export function loadNewVendorSharedReport2025(link_id, p1, p2) {
    return dispatch => {
        let url =
            "/IRISReportsMicroservice/api/SharedLink/report_link/" + link_id + "/" + p1 + "/" + p2;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(async function (json) {
                var link: LinkStuff = json;
                if (link.link_id == -1) {
                    dispatch({
                        type: "BAD_LINK",
                        payload: json
                    });
                    dispatch(push('/reports/bad_link'));
                } else {
                    authenticateUserOutsideLogin().then(userFound => {
                        dispatch(handleReportDisplayIdChange_VendorReport2025({ value: link.display_id }));

                        userFound.report_vintage_vendor2025 = link.vintage;
                        dispatch({
                            type: "SAVE_REPORT_VINTAGE_VENDOR2025",
                            payload: userFound
                        })
                        dispatch(loadNewVendorReportTab12025(link.display_id, "2019Q4A", link.vintage));                        
                    });


                }
            });
    };
}

export function loadReleaseDate2025(display_id, vintage) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/VendorReport2025/get_vendor_release_date2025/' + display_id + '/' + vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "VENDOR_RELEASE",
                    payload: json['release_date']
                })
            });
    };
}

// TODO: correct multiple nested actions creator functions such as this (loadHomeState_AndOtherStuff) into single-purpose functions
// ... each action creator which makes an API call should not call other action creators which also makes API calls

export function loadSunburstBVDData2025(display_id, vintage, homestate, year_range, bvdmatchrates, institutionName, possessiveInstitutionName) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/VendorReport2025/get_sunburst_bvd_data/' + display_id + '/' + vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "GET_SUNBURST_BVD_DATA",
                    payload: json
                })
                dispatch(loadSunburstBVDBulletPoint2025(display_id, vintage, homestate, year_range, bvdmatchrates, json, institutionName, possessiveInstitutionName));
                
            });
    };
}

export function loadSunburstBVDBulletPoint2025(display_id, vintage, homestate, year_range, bvdmatchrates, bvddata, institutionName, possessiveInstitutionName) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/VendorReport2025/get_bvd_sunburst_bulletpoint/' + display_id + '/' + vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "GET_BVD_SUNBURST_BULLETPOINT",
                    payload: json
                })
                dispatch(setTab42025(display_id, homestate, bvddata, year_range, bvdmatchrates, json, institutionName, possessiveInstitutionName));
            });
        
    };
}

export function loadBVDMatchRates2025(display_id, vintage, homestate, institutionName) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/VendorReport2025/get_bvd_matchrates/' + display_id + '/' + vintage;
        const agg = isAgg(display_id);
        const possessiveInstitutionName = getPossessiveInstitutionName(agg, institutionName);
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                BVD_MATCH_RATES = json;
                dispatch({
                    type: "GET_BVD_MATCHRATES",
                    payload: json
                })
                dispatch(loadVendorProfile_Tab12025(display_id, vintage, homestate, homestate?.campusname, json, institutionName, possessiveInstitutionName));

                let uniName = agg ? institutionName.replace('Member', 'member').replace('Universities', 'universities') : `your university`;
                let uniNameWithS = getPossessiveInstitutionName(agg, uniName);

                var bvd_match = `For this report, metrics are based on data ${Helpers.aggUniversityAlternateName_LowerCase(uniName)} submitted as of ${json.submission_date.substring(0, 10)}. Of ${numberWithCommas(json.total_count)} unique vendors and subawardees, ${percentageFormat(json.uS_count_pct, 1)} or ${numberWithCommas(json.uS_total_count)} were in the U.S., accounting for ${percentageFormat(json.uS_pmt_pct, 1)} or ${billionNumberFormat(json.uS_total_payment_amt)} of ${uniNameWithS} spending. Of that U.S. based spending, ${percentageFormat(json.uS_biz_pmt_pct, 1)} or ${billionNumberFormat(json.uS_biz_total_pmt_amt)} went to ${numberWithCommas(json.uS_biz_total_count)} organizations rather than individual people. Name and address-based matching linked ${Math.round(json.matched_business_count_pct * 100) + '%'} or ${numberWithCommas(json.matched_business_total_count)} of these U.S. organizations, accounting for ${Math.round(json.matched_business_pmt_pct * 100) + '%'} (${billionNumberFormat(json.matched_business_total_amt)}) of spending, to IRIS business directory data.`

                dispatch({
                    type: "VENDOR_MATCHTAB",
                    payload: { bvd_match: bvd_match } 
                })
            });
    };
}


export function downloadNewVendorReportData2025(vendorState, userState) {
    return async (dispatch) => {
        let {                
            VendorProfileTab1AllData,            
            SunburstBVDData,
            SunburstBulletPoint,
            BVDMatchRates
        }
            = vendorState;
        const vendorProfilesByYearCsv = arrayToCsv({ data: VendorProfileTab1AllData });
        const sunburstBVDFixed = SunburstBVDData.map(item => {
            return Object.keys(item).reduce((acc, key) => {
                let newKey = key;
                if (key === 'naicS_LABEL') {
                    newKey = 'NAICS_LABEL';
                }
                acc[newKey] = item[key];
                return acc;
            }, {});
        });
        const sunburstBVDCsv = arrayToCsv({ data: sunburstBVDFixed });
        const sunburstBulletPointCsv = arrayToCsv({ data: SunburstBulletPoint });        
        const BVDMatchRatesFixed = Object.keys(BVDMatchRates).reduce((acc, key) => {
            let newKey = key;
            if (key.startsWith('uS_')) {
                newKey = 'US_' + key.substring(3);
            }
            acc[newKey] = BVDMatchRates[key];
            return acc;
        }, {});
        const BVDMatchRatesCsv = arrayToCsv({ data: [BVDMatchRatesFixed] });

        const zip = new JSZip();
        zip.file('vendorProfilesByYear.csv', vendorProfilesByYearCsv);
        zip.file("sunburst.csv", sunburstBVDCsv);
        zip.file("sunburstBulletPoint.csv", sunburstBulletPointCsv);
        zip.file("MatchRates.csv", BVDMatchRatesCsv);
        try {
            const readmeResp = await fetch('/IRISReportsMicroservice/api/VendorReport2025/readme');
            if (readmeResp.ok) {
                const readmeBlob = await readmeResp.blob();
                zip.file("README.txt", readmeBlob);
            }
        } catch (e) {
            // ignore if readme missing
        }

        zip.generateAsync({ type: "blob" })
            .then(function (blob) {
                saveAs(blob, "VendorReportData.zip");
            });


        //const name = 'VendorReportReadMe.pdf'
        //fetch('./dist/downloads/' + name)
        //    .then(res => res.arrayBuffer())
        //    .then(ab => {
        //        zip.file('readme.pdf', ab);
        //        zip.generateAsync({ type: "blob" })
        //            .then(function (blob) {
        //                saveAs(blob, "VendorReportData.zip");
        //            });
        //        dispatch({ type: "DOWNLOAD_VENDOR_REPORT_DATA" });
        //    })

    }
}

export function buildTitleText(
    agg?: boolean,
    institutionName?: string
): string {
    return agg
        ? `Vendor Profile Report for ${institutionName}`
        : `${institutionName} Vendor Profile Report`;
}

export function getPossessiveInstitutionName(
    agg?: boolean,
    institutionName?: string
): string {
    let possessiveInstitutionName = agg ? institutionName + "'" : institutionName + "'s";
    possessiveInstitutionName = replaceRu4mPossessive(possessiveInstitutionName);
    return `${possessiveInstitutionName}`;
}

export function getInstitutionName(campusName?: string) {
    let institutionName = campusName ?? "";
    const institutionAcronym = ((a, b) => a > -1 && b > a ? institutionName.slice(a + 1, b).trim() : "")(institutionName.indexOf("("), institutionName.indexOf(")"));
    if (institutionAcronym) {
        institutionName = institutionAcronym;
    }
    return institutionName
}